import { ratePoint, type Measurement, type RadioTechnology, type RatingLevel } from '@oscom/shared';

export interface RatingCombo {
  technology: RadioTechnology;
  provider: string;
  /** e.g. "Telekom 4G" */
  label: string;
}

/** Every technology of the series with every provider, technology order first. */
export function ratingCombos(
  technologies: readonly RadioTechnology[],
  providers: readonly string[],
): RatingCombo[] {
  return technologies.flatMap((technology) =>
    providers.map((provider) => ({ technology, provider, label: `${provider} ${technology}` })),
  );
}

/** Level of the strongest cell for the chosen combination, as in A; null = `---`. */
export function markerLevel(
  measurement: Pick<Measurement, 'cells'> | undefined,
  combo: Pick<RatingCombo, 'technology' | 'provider'> | undefined,
): RatingLevel | null {
  if (!measurement || !combo) return null;
  return ratePoint(measurement.cells, [combo.technology], [combo.provider])[0]?.level ?? null;
}

export function ratingClass(level: RatingLevel | null): string {
  return level === null ? 'rating--none' : `rating--${level}`;
}
